import type { ReactNode } from "react";
import { SyncStatusText } from "./SyncStatusText.tsx";
import { SyncStatusTooltip } from "./SyncStatusTooltip.tsx";
import type { SyncStatusPresentation } from "./syncStatusPresentation.ts";

type Props = {
	status: SyncStatusPresentation | null;
	iconPosition: "leading" | "trailing";
	children?: ((status: SyncStatusPresentation) => ReactNode) | undefined;
	className?: string | undefined;
};

export const SyncStatus = ({
	status,
	iconPosition,
	children,
	className,
}: Props) => {
	if (!status) {
		return <span className="text-grey-400">–</span>;
	}
	return (
		<SyncStatusTooltip status={status}>
			<SyncStatusText
				status={status}
				iconPosition={iconPosition}
				className={className}
			>
				{children ? (
					children(status)
				) : (
					<span className="truncate">{status.word}</span>
				)}
			</SyncStatusText>
		</SyncStatusTooltip>
	);
};
